import request from "@/utils/request";

// 获取开票列表
export function getInvoiceList(data) {
  return request({
    method: "post",
    path: "invoice/lists",
    data,
  });
}

// 获取待开票列表
export function getApplyList(data) {
  return request({
    method: "post",
    path: "invoice/getApplyList",
    data,
  });
}

// 获取开票预览
export function getInvoicePreview(data) {
  return request({
    method: "post",
    path: "invoice/preview",
    data,
  });
}

// 获取开票详情
export function getInvoiceDetail(data) {
  return request({
    method: "post",
    path: "invoice/detail",
    data,
  });
}

// 保存开票
export function addInvoice(data) {
  return request({
    method: "post",
    path: "invoice/submit",
    data,
  });
}

// 获取开票列表（所有）
export function getAllInvoiceList(data) {
  return request({
    method: "post",
    path: "invoice/all",
    data,
  });
}

// 上传合同
export function uploadContract(data) {
  return request({
    method: "post",
    path: "invoice/uploadContract",
    data,
  });
}

// 获取打印预览
export function getPrintPreview(data) {
  return request({
    method: "post",
    path: "invoice/getPrintPreview",
    data,
  });
}